<div class="text-center">
    <mat-icon>developer_board</mat-icon>
    <h1 mat-dialog-title translate> dialog.slotmodel.apply</h1>
  
    <div class="modal-body" mat-dialog-content>
  
        <help-alert text = "help.page.new_service.field" info = "help.info" description = "help.page.new_service.description"></help-alert>

        <div class="card container">
            <div class="row mt-2">
                <div class="col-md">
                    <mat-form-field>
                    <mat-label translate>dialog.slotmodel.service</mat-label>
                    <mat-select [(ngModel)]="param.serviceId" required matNativeControl>
                        <mat-option *ngFor="let service of param.services" [value]="service.id">
                        {{service.name}}
                        </mat-option>
                    </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md">
                    <mat-form-field>
                    <mat-label translate>dialog.slotmodel.model</mat-label>
                    <mat-select [(ngModel)]="param.model" required matNativeControl>
                        <mat-option *ngFor="let model of models" [value]="model.id">
                        {{model.name}}
                        </mat-option>
                    </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div class="card container mt-3">
            <div class="row mt-2">
                <div class="col-sm">
                    <mat-form-field>
                    <mat-label translate>dialog.slotmodel.dateFrom</mat-label>
                    <input  matInput 
                        [(ngModel)]     = "param.dateFrom"
                        (change) = "checkDate()" 
                        [min]           = "today"
                        [max]           = "param.dateTo"
                        [matDatepicker] = "dateFrom">
                    <mat-datepicker-toggle matSuffix [for] ="dateFrom">
                        <mat-icon  matDatepickerToggleIcon>date_range</mat-icon>
                    </mat-datepicker-toggle>
                    <mat-datepicker #dateFrom></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="col-sm">
                    <mat-form-field>
                    <mat-label translate>dialog.slotmodel.dateTo</mat-label>
                    <input  matInput 
                        [(ngModel)]     = "param.dateTo" 
                        (change) = "checkDate()"
                        [min]           = "param.dateFrom"
                        [matDatepicker] = "dateTo">
                    <mat-datepicker-toggle matSuffix [for] ="dateTo">
                        <mat-icon matDatepickerToggleIcon>date_range</mat-icon>
                    </mat-datepicker-toggle>
                    <mat-datepicker #dateTo></mat-datepicker>
                    </mat-form-field>
                </div>                
            </div>
        </div>

        <div class="card container mt-3">
            <div class="row mt-2">
                <div class="col-sm">
                    <mat-checkbox [(ngModel)]="param.holiday">
                        <span translate>dialog.slotmodel.holiday</span>
                    </mat-checkbox>
                </div> 
            </div> 
            <div class="row mt-2">    
                <div class="col-sm">
                    <mat-checkbox [(ngModel)]="param.delete">
                        <span translate>dialog.slotmodel.delete</span>
                    </mat-checkbox>
                </div>               
            </div>
        </div>

  
      
    </div>
  
  
    <div class="modal-footer" mat-dialog-actions translate>

        <button type="button" class="btn btn-outline-danger" (click)="cancel()" translate>
        dialog.service.generic.cancel
        </button>

        <button type="button" class="btn btn-outline-secondary" (click)="apply()"
        translate>
        dialog.service.update.confirm
        </button>


    </div>

</div>